import { metaTagString } from '../../utilities/meta_tags_util';

export default (urlPath, language, query, params) => {
  const TITLE = {
    en: 'My Points Summary',
    ja: 'ポイント獲得・利用履歴',
    ko: '포인트조회',
    'zh-tw': '點數獲得・使用紀錄',
    'zh-cn': '点数获得/使用历史'
  };
  const DESCRIPTION = {
    en: 'Start to earn Fun Points and save up to 5% upon purchase today',
    ja: '商品を購入で FUN ポイントが貯まり、次回のお支払いで最大 5% OFF！今すぐお買い物しよう！',
    ko: 'FUN 포인트 적립 까지지금 시작하세요! 결제 시 최대 5% 청구할인.',
    'zh-tw': '累積 Fun Points 可享單筆訂單最高 5％ 折扣',
    'zh-cn': '累积 Fun Points 可享单笔订单最高 5％ 折扣'
  };

  const metaData = metaTagString({
    urlPath,
    title: TITLE[language],
    description: DESCRIPTION[language],
    language,
    noindex: true
  });

  return { metaData };
};
